"use strict";
// ============================================================
// GraphicSIMS / NewBlue Enterprise — Shared Type Definitions
// ============================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonFlowState = exports.WSMessageType = exports.RoomState = exports.MultiplayerRole = exports.QuizQuestionType = exports.LessonEventType = exports.LessonType = exports.SubscriptionLevel = exports.UserRole = void 0;
// --- Roles & Auth ---
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["MANAGER"] = "manager";
    UserRole["TEACHER"] = "teacher";
    UserRole["STUDENT"] = "student";
    UserRole["ENTERPRISE"] = "enterprise";
    UserRole["APPRENTICE"] = "apprentice";
})(UserRole || (exports.UserRole = UserRole = {}));
var SubscriptionLevel;
(function (SubscriptionLevel) {
    SubscriptionLevel["VIDEO_CLUB"] = "video_club";
    SubscriptionLevel["STUDIO"] = "studio";
    SubscriptionLevel["CONTROL_ROOM"] = "control_room";
})(SubscriptionLevel || (exports.SubscriptionLevel = SubscriptionLevel = {}));
// --- Lessons ---
var LessonType;
(function (LessonType) {
    LessonType["CORE"] = "core";
    LessonType["CAPSTONE"] = "capstone";
    LessonType["MULTIPLAYER"] = "multiplayer";
})(LessonType || (exports.LessonType = LessonType = {}));
var LessonEventType;
(function (LessonEventType) {
    /** Grade library navigation (find correct folder/template) */
    LessonEventType["NAVIGATE"] = "navigate";
    /** Grade template selection/loading */
    LessonEventType["TEMPLATE"] = "template";
    /** Grade property edits (correct text, correct data) */
    LessonEventType["EDIT"] = "edit";
    /** Grade shot creation/triggering */
    LessonEventType["SHOT"] = "shot";
    /** Grade data linking actions */
    LessonEventType["DATA"] = "data";
    /** Grade take/transition to program output */
    LessonEventType["PROGRAM"] = "program";
    /** Enable/disable UI elements, wait for action */
    LessonEventType["CONTROL"] = "control";
    /** Automated actions (advance state) */
    LessonEventType["AUTO"] = "auto";
})(LessonEventType || (exports.LessonEventType = LessonEventType = {}));
// --- Quiz ---
var QuizQuestionType;
(function (QuizQuestionType) {
    QuizQuestionType["MATCHING"] = "matching";
    QuizQuestionType["MULTIPLE_CHOICE"] = "multiple_choice";
    QuizQuestionType["FILL_BLANK"] = "fill_blank";
})(QuizQuestionType || (exports.QuizQuestionType = QuizQuestionType = {}));
// --- Multiplayer ---
var MultiplayerRole;
(function (MultiplayerRole) {
    MultiplayerRole["GRAPHICS_OPERATOR"] = "graphics_operator";
    MultiplayerRole["SHOT_DIRECTOR"] = "shot_director";
    MultiplayerRole["DATA_MANAGER"] = "data_manager";
    MultiplayerRole["PRODUCER"] = "producer";
    MultiplayerRole["SPECTATOR"] = "spectator";
})(MultiplayerRole || (exports.MultiplayerRole = MultiplayerRole = {}));
var RoomState;
(function (RoomState) {
    RoomState["LOBBY"] = "lobby";
    RoomState["LOADING"] = "loading";
    RoomState["COUNTDOWN"] = "countdown";
    RoomState["RUNNING"] = "running";
    RoomState["RESULTS"] = "results";
})(RoomState || (exports.RoomState = RoomState = {}));
// --- WebSocket Messages ---
var WSMessageType;
(function (WSMessageType) {
    // Client → Server
    WSMessageType["JOIN_ROOM"] = "join_room";
    WSMessageType["LEAVE_ROOM"] = "leave_room";
    WSMessageType["PLAYER_READY"] = "player_ready";
    WSMessageType["START_SIMULATION"] = "start_simulation";
    WSMessageType["PLAYER_ACTION"] = "player_action";
    // Server → Client
    WSMessageType["ROOM_UPDATE"] = "room_update";
    WSMessageType["SIMULATION_START"] = "simulation_start";
    WSMessageType["SIMULATION_EVENT"] = "simulation_event";
    WSMessageType["SCORE_UPDATE"] = "score_update";
    WSMessageType["SIMULATION_END"] = "simulation_end";
    WSMessageType["ERROR"] = "error";
    // Bidirectional
    WSMessageType["PING"] = "ping";
    WSMessageType["PONG"] = "pong";
})(WSMessageType || (exports.WSMessageType = WSMessageType = {}));
// --- Lesson State Machine ---
var LessonFlowState;
(function (LessonFlowState) {
    LessonFlowState["SELECT"] = "select";
    LessonFlowState["PRELOAD"] = "preload";
    LessonFlowState["INTRO"] = "intro";
    LessonFlowState["SIMULATION"] = "simulation";
    LessonFlowState["QUIZ"] = "quiz";
    LessonFlowState["RESULTS"] = "results";
})(LessonFlowState || (exports.LessonFlowState = LessonFlowState = {}));
//# sourceMappingURL=index.js.map